// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

type Props = {
  isAuthenticated: boolean,
}

function DefaultRouteRedirect({ isAuthenticated }: Props) {
  if (!isAuthenticated) {
    return <Redirect to="/login" />;
  }

  return <Redirect to="/dashboard" />;
}

export default connect(
  state => ({
    isAuthenticated: state.session.isAuthenticated,
  }),
)(DefaultRouteRedirect);



// WEBPACK FOOTER //
// ./src/advertisers/modules/authorization/DefaultRouteRedirect.js